import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Button, Dropdown, Navbar, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import supabase from "../../supabase";
import { useRenovCredits } from "../../context/RenovCreditsContext";
import { useUserPlan } from "../../context/UserPlanContext"; // 🆕 Import du contexte
import "./Navbar.css";
import { useNotification } from "../../context/NotificationContext";

const NavigationBar = ({ showBackButton = false }) => {
  const navigate = useNavigate();
  const { renovCredits } = useRenovCredits();
  const { userPlan, accountType } = useUserPlan(); // 🆕 Récupération du plan via le contexte
  const { showNotification } = useNotification();

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      setIsAuthenticated(!!user);
    };

    checkUser();

    const { subscription } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setIsAuthenticated(!!session?.user);
      }
    );

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      setIsAuthenticated(false);
      showNotification("Vous avez été déconnecté.", "info");
      navigate("/");
    } catch (error) {
      console.error("Erreur lors de la déconnexion :", error);
      showNotification("Erreur lors de la déconnexion.", "danger");
    }
  };

  return (
    <Navbar className="navigation-bar" expand="lg" sticky="top">
      <Container fluid className="navigation-bar-container">
        <div className="d-flex align-items-center">
          <Navbar.Brand
            href="/"
            className="d-flex align-items-center"
            onClick={() => navigate("/")}
          >
            <img
              src="/NewLogoR_resized_2.png"
              alt="RenovEstim"
              width="60"
              height="40"
              className="navbar-logo-img"
            />
            <span className="navbar-brand-text ms-2">novEstim</span>
          </Navbar.Brand>
          {showBackButton && (
            <Button
              variant="light"
              onClick={() => navigate(-1)}
              className="navigation-bar-back-button ms-3"
            >
              ← Retour
            </Button>
          )}
        </div>

        {!isAuthenticated ? (
          <div className="d-flex align-items-center ms-auto">
            <Button
              className="me-3"
              onClick={() => navigate("/inscription-artisan")}
              style={{
                backgroundColor: "var(--primary-dark-text)",
                borderColor: "var(--primary-dark-text)",
              }}
            >
              Je suis un pro
            </Button>
            <Button variant="success" onClick={() => navigate("/login")}>
              Se connecter
            </Button>
          </div>
        ) : (
          <div className="d-flex align-items-center ms-auto">
            <div className="user-plan-display me-3">
              <i className="bi bi-gem"></i> {userPlan}
            </div>
            {renovCredits !== undefined && accountType !== "Artisan" && (
              <div className="renovcredits-display me-3">
                <i className="bi bi-coin"></i> {renovCredits} RC
              </div>
            )}
            <Dropdown drop="down-centered" align="end">
              <Dropdown.Toggle
                variant="light"
                className="navigation-bar-user-dropdown d-flex align-items-center"
                style={{
                  backgroundColor: "var(--secondary-light-bg)",
                  color: "var(--primary-dark-text)",
                }}
              >
                <i className="bi bi-person-circle"></i> Mon compte
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => navigate("/moncompte")}>
                  <i className="bi bi-person"></i> Gérer mon compte
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleLogout} className="text-danger">
                  <i className="bi bi-box-arrow-right"></i> Déconnexion
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
